let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kiXKy")).then(() => parcelRequire('lnh2Q'));